module.exports = __webpack_public_path__ + "img/tasks-w.df454d0b.svg";